import axios from 'axios';
import i18n from '@/locales';
import { applyAcceptLanguageHeader } from '@/utils/requestLanguage';
export var SUCCESS_CODE = '000000';
// 创建一个axios实例
var service = axios.create({
  // 请求超时时间
  timeout: 3000
});

// 添加请求拦截器
service.interceptors.request.use(function (config) {
  return applyAcceptLanguageHeader(config, i18n.locale);
}, function (err) {
  console.log(err);
});

//响应拦截
service.interceptors.response.use(function (response) {
  var res = {};
  res.status = response.status;
  res.data = response.data;
  return res;
}, function (err) {
  return console.log(err);
});
export default service;